export const CONSULTATION_LIST_ENDPOINT = `/api/consultations`
